import React from "react";

export const mainParagraph = (
  <div className="mainParagraph">
    <p className="content justified">
      Los pixies, hadas, sirenas, brownies, leprechauns y ogros son la esencia de un corto texto en el que Oswaldo Díaz
      Díaz describe brevemente cuáles son las características de estos seres fantásticos, cómo lucen, dónde viven,
      cuáles son sus travesuras favoritas y a qué dedican sus días.
    </p>
    <p className="content justified">
      En este texto dirigido a los niños, advierte que es mejor cuidar de los hermanitos pequeños si se está cerca de la
      presencia de un troll que, aunque sea amable y complaciente, no puede evitar llevarse consigo lo que le es ajeno,
      especialmente si se trata de un niño pequeño.
    </p>
    <p className="content justified">
      También señala que cuando los niños y niñas alemanes se equivocan en un paso de danza, saben que es por obra de
      las nixies, que adoran la música y el canto, y enredan los pies de los pequeños bailarines.
    </p>
  </div>
);

export const bottomParagraph = (
  <div className="bottomParagraph">
    <p className="content justified">
      Díaz Díaz no solo dedica su escrito a los conocidos duendes y hadas europeos, sino que recuerda a los seres
      fantásticos del Medio Oriente que aparecen en <i>Las mil y una noches</i>, como los jinnis, los afreets y las
      peris.
    </p>
    <p className="content justified">
      Y sigue su recorrido por el mundo real y el imaginario, recordando a los animales propios del país de las hadas
      como los dragones, los grifos y los hipogrifos; y a aquellos que narra la mitología griega: el minotauro, los
      centauros y unicornios, entre muchos otros.
    </p>
    <p className="content justified">
      Llama la atención cómo se enlazan en este texto tres hechos: el estreno de la película <i>Peter Pan</i>, en 1953;
      la lectura del libro <i>The Fairy Dictionary</i> (El diccionario de las hadas) de George M. Richards (McMillan,
      1940); y un inicio en el que nuestro autor busca crear un vínculo entre la fantasía europea y la colombiana.
    </p>
    <p className="content justified">
      Parece que la pequeña Campanita de la película de <i>Peter Pan</i> despertó la curiosidad en este autor, quien
      buscó información sobre estos mundos imaginarios e intentó establecer un vínculo entre los duendes locales y los
      elfos.
    </p>
    <p className="content justified">
      Aunque no intente encontrar otras equivalencias, el texto da buena cuenta de los seres de esos mundos imaginarios
      en donde reinan "Oberón y Titania, acompañados por el más listo y pícaro de los duendes, Puck; como lo supo muy
      bien Shakespeare al escribir su <i>Sueño de una noche de verano.</i>
    </p>
  </div>
);

export const sections = <div className="sectionsReview"></div>;
